module.exports = __webpack_public_path__ + "static/media/ICONO_BOLSA.23561ba6.webp";